import { calcMonthlyStats } from './turniStats';
import { fetchTurniByMonth, fetchFerieRequests } from '../services/turniService';
import { generateMensialePdf } from './generateTurniPdf';

export const computePdfDoc = async (filtered, allDays, turniData, managerFerieList, reperibilitaData) => {
  const selectedMonthStr = allDays[0]?.fullDate?.substring(0, 7);
  const [year, monthNum] = selectedMonthStr
    ? selectedMonthStr.split('-').map(Number)
    : [new Date().getFullYear(), new Date().getMonth() + 1];

  const monthsKeys = Array.from({ length: monthNum }, (_, i) => `${year}-${String(i + 1).padStart(2, '0')}`);
  const [allMonthsTurni, allFerie] = await Promise.all([
    Promise.all(monthsKeys.map(m => fetchTurniByMonth(m).then(data => [m, data || []]).catch(() => [m, []]))).then(Object.fromEntries),
    fetchFerieRequests().catch(() => []),
  ]);

  const cumulativeBalances = {};
  filtered.forEach(user => {
    const uName = `${user.nome} ${user.cognome}`.trim();
    let cumulo = 0;
    monthsKeys.forEach(monthStr => {
      const [y, m] = monthStr.split('-').map(Number);
      const daysInMonth = new Date(y, m, 0).getDate();
      const monthDays = Array.from({ length: daysInMonth }, (_, i) => ({ fullDate: `${monthStr}-${String(i + 1).padStart(2, '0')}` }));
      const stats = calcMonthlyStats(monthDays, allMonthsTurni[monthStr] || [], allFerie, user);
      cumulo += stats.workedHours + stats.ferieHours + stats.permessiHours + stats.malattiaHours - stats.oreMensiliContratto;
    });
    cumulativeBalances[uName] = +Number(cumulo).toFixed(1);
  });

  return generateMensialePdf({ allDays, collaboratorsList: filtered, turniData, managerFerieList, reperibilitaData: reperibilitaData || [], cumulativeBalances });
};
